import { PageListDataSource } from './BaseDataSources';
import { IOrganization } from '../Interfaces';

export class OrganizationSource extends PageListDataSource<IOrganization> {
  public constructor() {
    super('/datasource/organizations');
  }
}